module.exports = __webpack_public_path__ + "img/garden-benches.4007195b.webp";